export default __webpack_public_path__ + "static/media/sibling-rivalry@2x 3.85734864.png";